export const LINK_PLAY_STORE = 'https://play.google.com/store/apps/dev?id=7767701652145321334';
export const LINK_APPLE_STORE = 'https://apps.apple.com/us/developer/gotiva-sp-z-o-o/id1656263188';
export const LINK_SINGULAR = 'https://jpu.sng.link/Dk2o2/axgy/qgzk';
export const LINK_PRIMIO = 'https://primio.dev';
export const LINK_PRIMIO_DOCS = 'https://primio.dev/docs/';
